export default {
  section: 'Paquetes',
  loading: 'Cargando paquetes...',
  actions: {
    save: 'Guardar',
    create: 'Crear',
    close: 'Cerrar',
    confirm: 'Confirmar'
  },
  modals: {
    create: {
      title: 'Crear paquete'
    },
    edit: {
      title: 'Editar paquete'
    },
    attach: {
      title: 'Enviar al menú'
    },
    remove: {
      title: '¿Deseas eliminar el paquete?',
      tooltip: 'Eliminar paquete'
    }
  },
  labels: {
    name: 'Nombre',
    internalId: 'ID',
    price: 'Precio de venta',
    recipe: 'Platillo',
    quantity: 'Cantidad',
    section: 'Sección'
  },
  placeholders: {
    recipe: 'Platillo/Bebida para agregar',
    quantity: '¿Qué tanto habrá en el paquete?'
  },
  headers: {
    name: 'Nombre',
    price: 'Precio de venta',
    cost: 'Costo',
    unitCost: 'Costo unitario',
    calculatedCost: 'Costo total',
    weeklySale: 'Promedio de venta semanal',
    status: 'Estado',
    sections: 'Secciones',
    actions: 'Acciones',
    quantity: 'Cantidad'
  }
}
